/* ==========================================================================
   AMADA 自建评论区（数据源：Judge.me 公开 widget 接口）
   --------------------------------------------------------------------------
   为什么自建而不用官方 widget：见 sections/amada-reviews.liquid 文件头。

   数据通道（免鉴权 + 浏览器 CORS 放行，2026-08-03 实测）：
     GET https://judge.me/reviews/reviews_for_widget
         ?url=<shop>.myshopify.com&shop_domain=<同>&platform=shopify
         &product_id=<数字 id>&page=N&per_page=30
     返回 number_of_reviews / average_rating / histogram / photo_gallery /
          reviews[]（含 location_country_code、product_title、product_url）
     ⚠️ per_page 服务端硬上限 30，要全量必须翻页（曾写 per_page=100 只回 30，
        导致关键词只从前 30 条算、去重也不准）。

   稿：
     PC     figma-qa/specs/reviews-pc-2026-08-03.md（节点 2012:87）
     移动   figma-qa/specs/reviews-mobile-2026-08-03.md（节点 101:5210）
   ========================================================================== */
(function () {
  'use strict';
  /* 2026-10-06：只执行一次。快速预览资源改为全站加载（购物车抽屉推荐「+」开快速预览），
     PDP / 分类页自己也会挂同一个文件 → 同一页出现两个 <script src>，第二份直接让位，
     否则事件委托会绑两遍（点一次触发两次）。 */
  if (window.__amadaReviewsLoaded) return;
  window.__amadaReviewsLoaded = true;

  var API = 'https://judge.me/reviews/reviews_for_widget';
  var PAGE_SIZE = 30; // 服务端上限，别改大
  var CACHE_TTL = 5 * 60 * 1000; // 5 分钟：评论不是实时数据，但也不该整个会话不更新

  /* 排序选项 —— 文案与 key 均按 PC 稿 7.2 / 移动稿 8.2 原样照抄。
     稿里触发行显示 RECOMMENDED、面板里写 RECOMMEND（多一个 D），这不是笔误是稿如此。 */
  var SORT_OPTIONS = [
    { key: 'recommend', label: 'RECOMMEND', activeLabel: 'RECOMMENDED' },
    { key: 'recent', label: 'MOST RECENT', activeLabel: 'MOST RECENT' },
    { key: 'rating_desc', label: 'RATING: HIGH TO LOW', activeLabel: 'RATING: HIGH TO LOW' },
    { key: 'rating_asc', label: 'RATING: LOW TO HIGH', activeLabel: 'RATING: LOW TO HIGH' },
    { key: 'pictures', label: 'WITH PICTURES', activeLabel: 'WITH PICTURES' },
    /* VIEW PRODUCT ITSELF 已按运营要求下掉（2026-08-04）。
       applyFilters 里 this_product 的分支保留 —— 没配跨商品聚合时它和默认结果一样，
       留着不影响任何行为，将来若要恢复这个入口，只需把选项加回本数组。 */
  ];

  /* 关键词提取的停用词。评论文本里高频但无检索价值的词，
     不过滤的话 TOP MENTIONS 会全是 the/and/very/it。 */
  var STOP_WORDS =
    ('a about after all also am an and any are as at be because been before being but by can cant could did do does ' +
      'doing dont down each even ever every few for from further get got had has have having he her here hers him his ' +
      'how i if in into is it its itself just me more most much my no nor not now of off on once only or other våre our ' +
      'out over own same she should so some such than that the their them then there these they this those through to ' +
      'too under until up us very was we well were what when where which while who whom why will with would you your ' +
      'im ive id ill youre thats dont didnt doesnt isnt wasnt arent cant couldnt wouldnt shouldnt wont ' +
      'one two three them theyre weve etc via per one').split(' ');

  var STOP_SET = {};
  for (var s = 0; s < STOP_WORDS.length; s++) STOP_SET[STOP_WORDS[s]] = true;

  /* 国家码 → 展示名。稿里 LOCATION 面板列的是全大写国家名（ALL REVIEWS / SINGAPORE / ...）。
     只收录 Judge.me 实际会返回的主要市场，未收录的直接用原始码兜底。 */
  var COUNTRY_NAMES = {
    US: 'UNITED STATES',
    CA: 'CANADA',
    GB: 'UNITED KINGDOM',
    AU: 'AUSTRALIA',
    SG: 'SINGAPORE',
    NZ: 'NEW ZEALAND',
    DE: 'GERMANY',
    FR: 'FRANCE',
    IT: 'ITALY',
    ES: 'SPAIN',
    NL: 'NETHERLANDS',
    JP: 'JAPAN',
    MX: 'MEXICO',
  };

  /* ------------------------------------------------------------------
     工具
     ------------------------------------------------------------------ */

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* 🚨 乱码兜底（2026-08-26）
     ------------------------------------------------------------------
     现象：评论正文里成对出现替换符方块，如 I<�><�>ve / didn<�><�>t / Comfortable<�><�>Soft。
     根因：**不是我们的代码**。Judge.me 接口返回的 JSON 原始字节里就是
           两个连续的 U+FFFD（EF BF BD EF BF BD），说明评论在导入 Judge.me
           之前就已经被错误编码解码过一次 —— 原文的 U+2019（'）和
           U+2014（—）这类「通用标点区」三字节字符被替换成了替换符。
           实证：curl Judge.me 接口拿到的字节 = b'I didn\xef\xbf\xbd\xef\xbf\xbdt have'；
           同一批评论在 Judge.me **官方 widget** 上也一样是乱码。
     治本：让运营在 Judge.me 后台修正/重新导入这些评论（我们改不了别人的数据库，
           也管不到官方 widget 的渲染）。
     治标：前端按上下文把 U+FFFD 还原回最可能的标点，避免用户看到方块。
           规则来自对本店全部乱码样本（20 处）的统计，逐条核对无误：
             · 后面紧跟 s/t/ve/ll/re/d/m + 词边界 → 撇号（didn't、I've、it's）
             · 其余一律 → em dash（"comfortable—soft"、"plus—I don't"）
           故意保守：只认这两种，不做更激进的猜测。 */
  var MOJIBAKE = /\uFFFD+/g;
  function fixMojibake(str) {
    if (!str || str.indexOf('\uFFFD') < 0) return str || '';
    return str.replace(MOJIBAKE, function (_m, offset, whole) {
      var rest = whole.slice(offset + _m.length);
      /* 缩写形式：'s 't 've 'll 're 'd 'm，且后面必须是词边界，
         否则 "comfortable\uFFFD\uFFFDsoft" 会因为 soft 以 s 开头被误判成撇号 */
      if (/^(s|t|ve|ll|re|d|m)\b/i.test(rest)) return '\u2019';
      /* 破折号：稿源里有 "comfortable\uFFFD\uFFFDsoft"（两侧紧贴）也有
         "position\uFFFD\uFFFD beyond"（后面带空格）。后者若直接替换会得到
         "position— beyond" 这种一边贴一边空的排版，补一个前导空格补齐。 */
      var prev = offset > 0 ? whole.charAt(offset - 1) : ' ';
      return prev !== ' ' && rest.charAt(0) === ' ' ? ' \u2014' : '\u2014';
    });
  }

  /* Judge.me 的 body_html 是它自己生成的富文本（只有 <p>/<br>/<em> 之类）。
     直接 innerHTML 会把它的标签一起渲染，但我们要按稿控制行高/字号，
     所以剥成纯文本再自己排版。 */
  /** 只解实体、不解析成活 DOM：DOMParser 产出惰性文档，用户内容里的 <img onerror> 不会触发 */
  function decodeEntities(str) {
    if (!str) return '';
    try {
      return new DOMParser().parseFromString(String(str), 'text/html').documentElement.textContent || '';
    } catch (e) {
      return String(str);
    }
  }

  function htmlToText(html) {
    if (!html) return '';
    var div = document.createElement('div');
    div.innerHTML = html;
    return fixMojibake((div.textContent || '').replace(/\s+/g, ' ').trim());
  }

  /* 稿的日期格式：`JUN 6,2025`（PC）/ `MAY 5 ,2025`（移动）。
     统一取 PC 的 `MON D,YYYY`，全大写。 */
  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ',' + d.getFullYear();
  }

  /* 吸顶导航高度 —— 只有 header 当前确实 fixed/sticky 时才占位，
     避免写死数值（铁律 8：--header-height 这类变量语义未核实，本函数改成实测）。
     scrollToReviews（顶部评分行跳转）与下面的分页/排序/筛选回顶共用同一份逻辑。 */
  function getStickyHeaderHeight() {
    var header = document.querySelector('.header--sticky, .header, [data-header]');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    return pos === 'fixed' || pos === 'sticky' ? header.getBoundingClientRect().height : 0;
  }

  /* prefers-reduced-motion 下瞬移，不做平滑滚动动画。 */
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function sessionGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || Date.now() - parsed.t > CACHE_TTL) return null;
      return parsed.v;
    } catch (e) {
      return null;
    }
  }

  function sessionSet(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: value }));
    } catch (e) {
      /* 隐私模式 / 配额满：缓存失败不影响功能 */
    }
  }

  /* ------------------------------------------------------------------
     数据层
     ------------------------------------------------------------------ */

  function buildUrl(shopDomain, productId, page) {
    return (
      API +
      '?url=' + encodeURIComponent(shopDomain) +
      '&shop_domain=' + encodeURIComponent(shopDomain) +
      '&platform=shopify' +
      '&product_id=' + encodeURIComponent(productId) +
      '&page=' + page +
      '&per_page=' + PAGE_SIZE
    );
  }

  /* 拉一个商品的全部评论。
     第 1 页拿到 total_pages 后并发拉剩余页 —— 串行翻页在 49 条（2 页）时无所谓，
     但聚合多个商品时会累积成明显延迟。 */
  function fetchProduct(shopDomain, productId) {
    var cacheKey = 'amada:reviews:' + shopDomain + ':' + productId;
    var cached = sessionGet(cacheKey);
    if (cached) return Promise.resolve(cached);

    return fetch(buildUrl(shopDomain, productId, 1))
      .then(function (res) {
        if (!res.ok) throw new Error('Judge.me ' + res.status);
        return res.json();
      })
      .then(function (first) {
        var totalPages = (first.pagination && first.pagination.total_pages) || 1;
        if (totalPages <= 1) return [first];

        var rest = [];
        for (var p = 2; p <= totalPages; p++) {
          rest.push(
            fetch(buildUrl(shopDomain, productId, p))
              .then(function (r) {
                return r.ok ? r.json() : null;
              })
              .catch(function () {
                return null; // 单页失败不拖垮整体，少几条比整块空白好
              })
          );
        }
        return Promise.all(rest).then(function (pages) {
          return [first].concat(pages.filter(Boolean));
        });
      })
      .then(function (pages) {
        var head = pages[0];
        var reviews = [];
        pages.forEach(function (page) {
          if (page && page.reviews) reviews = reviews.concat(page.reviews);
        });

        var result = {
          productId: String(productId),
          total: head.number_of_reviews || reviews.length,
          average: parseFloat(head.average_rating) || 0,
          histogram: head.histogram || [],
          photoGallery: head.photo_gallery || [],
          reviews: reviews,
        };
        sessionSet(cacheKey, result);
        return result;
      });
  }

  /* 聚合当前商品 + 稿里「globally」要求的同族商品。
     单个商品失败时不整体失败：主商品挂了才算失败，附加商品挂了就少那部分。 */
  function fetchAll(shopDomain, mainId, extraIds) {
    var tasks = [fetchProduct(shopDomain, mainId)];
    extraIds.forEach(function (id) {
      tasks.push(
        fetchProduct(shopDomain, id).catch(function () {
          return null;
        })
      );
    });

    return Promise.all(tasks).then(function (results) {
      var main = results[0];
      var all = results.filter(Boolean);

      var reviews = [];
      var total = 0;
      var weighted = 0;
      all.forEach(function (r) {
        reviews = reviews.concat(
          r.reviews.map(function (rev) {
            rev.__ownProduct = r.productId === String(mainId);
            return rev;
          })
        );
        total += r.total;
        weighted += r.average * r.total;
      });

      return {
        reviews: reviews,
        total: total,
        average: total ? weighted / total : 0,
        // 图库优先用主商品的（稿里轮播展示的是本商品买家秀）
        photoGallery: main.photoGallery.length ? main.photoGallery : [].concat.apply([], all.map(function (r) { return r.photoGallery; })),
      };
    });
  }

  /* ------------------------------------------------------------------
     关键词
     --------------------------------------------------------------------
     两个来源，运营配了就用运营的，没配就自动提取。
     统一的数据结构是 { label: 显示文案, terms: [匹配词…] } —— 之所以要把
     「显示什么」和「拿什么去匹配评论」拆成两个字段，见 parseCuratedKeywords 的注释。

     自动提取：Judge.me 免费版不返回 review_keywords（付费 Awesome 档才有 AI
     keywords），所以在前端自己算：一元词 + 二元短语混合统计，短语优先。
     语料只有几十条，用不着 TF-IDF —— 停用词 + 词频 + 短语合并已足够稳定。
     ------------------------------------------------------------------ */

  /* 判断一条评论是否命中某个关键词：任一 term 出现在正文或标题里即算（OR）。 */
  function reviewMatches(rev, terms) {
    var text = (htmlToText(rev.body_html) + ' ' + fixMojibake(rev.title)).toLowerCase();
    return terms.some(function (t) {
      return t && text.indexOf(t) !== -1;
    });
  }

  function matchCount(reviews, terms) {
    var n = 0;
    reviews.forEach(function (rev) {
      if (reviewMatches(rev, terms)) n++;
    });
    return n;
  }

  /* 解析后台配置。一行一个关键词，格式：
       显示文案: 匹配词1, 匹配词2, …
     冒号及之后可以整个省略，那样「显示文案」自身就是唯一匹配词。

     为什么必须支持「显示文案 ≠ 匹配词」：运营写的是营销话术，买家写的是口语。
     实测本商品 49 条评论 —— 运营给的 "Easy Assembly" 整串命中 0 条，
     但 "assembl" / "put together" 合起来命中 7 条；"Soft Fabric" 同样 0 条，
     拆成 "soft" / "fabric" 有 7 条。只按显示文案匹配的话，6 个词里 4 个是空的。 */
  function parseCuratedKeywords(raw) {
    if (!raw) return [];
    return raw
      .split(/[\r\n]+/)
      .map(function (line) {
        var t = line.trim();
        if (!t) return null;
        var i = t.indexOf(':');
        var label = (i === -1 ? t : t.slice(0, i)).trim();
        if (!label) return null;
        var terms = (i === -1 ? '' : t.slice(i + 1))
          .split(',')
          .map(function (s) {
            return s.trim().toLowerCase();
          })
          .filter(Boolean);
        if (!terms.length) terms = [label.toLowerCase()];
        return { label: label, terms: terms };
      })
      .filter(Boolean);
  }

  function tokenize(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9\s'-]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);
  }

  /* Judge.me 会给「只打星没写正文」的评论生成占位正文
     （实测 49 条里有 9 条是 `Verified purchase. Rated 5 stars.`）。
     这不是买家写的内容，混进关键词会让 TOP MENTIONS 出现「VERIFIED PURCHASE」。 */
  var PLACEHOLDER_BODY = /^\s*verified purchase\.?\s*(rated \d+ stars?\.?)?\s*$/i;

  function isPlaceholder(text) {
    if (!text) return true;
    if (PLACEHOLDER_BODY.test(text)) return true;
    if (text.replace(/[^a-z]/gi, '').length < 3) return true; // "K"、"..." 这类无效评论
    return false;
  }

  /* 商品自身的词（sofa / couch / sectional / 品牌名…）在本商品的评论里必然高频，
     但「这个沙发的评论里提到沙发」没有筛选价值 —— 用商品标题动态构建排除集，
     比硬编码一张品类词表可靠（换品类不用改代码）。 */
  function productStopSet(productTitle) {
    var set = {};
    tokenize(productTitle || '').forEach(function (w) {
      if (w.length >= 3) set[w] = true;
      // 单复数都排：sofa/sofas
      set[w + 's'] = true;
      if (/s$/.test(w)) set[w.slice(0, -1)] = true;
    });
    // 同义品类词：标题里写 sofa，买家常写 couch，两者都该排除
    ['couch', 'couches', 'sofa', 'sofas', 'chair', 'chairs', 'furniture', 'product', 'item', 'amada'].forEach(function (w) {
      set[w] = true;
    });
    return set;
  }

  function extractKeywords(reviews, limit, productTitle) {
    var uniCount = {};
    var biCount = {};
    var productWords = productStopSet(productTitle);

    reviews.forEach(function (rev) {
      var body = htmlToText(rev.body_html);
      if (isPlaceholder(body)) return; // 占位/无效评论不参与词频

      var text = body + ' ' + fixMojibake(rev.title);
      var words = tokenize(text);
      var kept = [];

      words.forEach(function (w) {
        if (w.length < 3) return;
        if (STOP_SET[w] || productWords[w]) return;
        if (/^\d+$/.test(w)) return;
        // 简单复数归一：sofas → sofa，避免同词分裂成两个关键词
        var norm = w.length > 4 && /[^s]s$/.test(w) ? w.slice(0, -1) : w;
        if (productWords[norm]) return;
        uniCount[norm] = (uniCount[norm] || 0) + 1;
        kept.push({ raw: w, norm: norm });
      });

      // 二元短语：只在原文里相邻（中间没被停用词切断）时才算
      for (var i = 0; i < words.length - 1; i++) {
        var a = words[i];
        var b = words[i + 1];
        if (a.length < 3 || b.length < 3) continue;
        if (STOP_SET[a] || STOP_SET[b]) continue;
        if (productWords[a] || productWords[b]) continue;
        if (/^\d+$/.test(a) || /^\d+$/.test(b)) continue;
        var phrase = a + ' ' + b;
        biCount[phrase] = (biCount[phrase] || 0) + 1;
      }
      return kept;
    });

    var candidates = [];

    // 短语权重乘 2：两个词的短语比单词更有信息量，但出现次数天然更少
    Object.keys(biCount).forEach(function (phrase) {
      if (biCount[phrase] >= 2) candidates.push({ term: phrase, score: biCount[phrase] * 2, words: phrase.split(' ') });
    });
    Object.keys(uniCount).forEach(function (word) {
      if (uniCount[word] >= 2) candidates.push({ term: word, score: uniCount[word], words: [word] });
    });

    candidates.sort(function (a, b) {
      return b.score - a.score;
    });

    // 去重：短语已覆盖的单词不再单独出现（避免 "great quality" 和 "quality" 并列）
    var chosen = [];
    var used = {};
    for (var c = 0; c < candidates.length && chosen.length < limit; c++) {
      var cand = candidates[c];
      var overlap = cand.words.some(function (w) {
        return used[w];
      });
      if (overlap) continue;
      cand.words.forEach(function (w) {
        used[w] = true;
      });
      // 自动提取的词，显示文案和匹配词是同一个
      chosen.push({ label: cand.term, terms: [cand.term] });
    }

    return chosen;
  }

  /* 运营配了词就用运营的，否则回退到自动提取。
     命中 0 条的 chip 直接不显示 —— 点了出一片空白比少一个 chip 糟得多。
     全部 0 命中时（比如运营配的一整套都和评论对不上）也回退到自动提取，
     否则 TOP MENTIONS 整块消失，比显示自动词更差。 */
  function resolveKeywords(reviews, curatedRaw, limit, productTitle) {
    var curated = parseCuratedKeywords(curatedRaw);
    if (curated.length) {
      var alive = curated.filter(function (k) {
        return matchCount(reviews, k.terms) > 0;
      });
      if (alive.length) return alive.slice(0, limit);
    }
    return extractKeywords(reviews, limit, productTitle);
  }

  /* ------------------------------------------------------------------
     筛选与排序
     ------------------------------------------------------------------ */

  function applyFilters(reviews, state) {
    var out = reviews;

    // 按选中关键词背后的匹配词组筛（任一命中即算），不是按 chip 上显示的文案筛
    if (state.keyword && state.keywordTerms && state.keywordTerms.length) {
      out = out.filter(function (rev) {
        return reviewMatches(rev, state.keywordTerms);
      });
    }

    if (state.country) {
      out = out.filter(function (rev) {
        return (rev.location_country_code || '').toUpperCase() === state.country;
      });
    }

    if (state.sort === 'this_product') {
      out = out.filter(function (rev) {
        return rev.__ownProduct;
      });
    } else if (state.sort === 'pictures') {
      out = out.filter(function (rev) {
        return rev.pictures_urls && rev.pictures_urls.length;
      });
    }

    var sorted = out.slice();
    switch (state.sort) {
      case 'recent':
        sorted.sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        break;
      /* 同分必须再定一个次序：本商品 49 条里 43 条是 5 星，只按 rating 排的话
         「高到低」的前几页和默认排序看起来一模一样（都是 5 星），用户会判定排序没生效。
         次序取时间倒序 —— 同为 5 星时先看最新的，是可解释也可感知的行为。 */
      case 'rating_desc':
        sorted.sort(function (a, b) {
          return b.rating - a.rating || new Date(b.created_at) - new Date(a.created_at);
        });
        break;
      case 'rating_asc':
        sorted.sort(function (a, b) {
          return a.rating - b.rating || new Date(b.created_at) - new Date(a.created_at);
        });
        break;
      default:
        /* recommend / pictures / this_product：
           推荐 = 有图 > 有正文 > 点赞多 > 新，让首屏尽量是「有内容的评论」 */
        sorted.sort(function (a, b) {
          var score = function (r) {
            return (
              (r.pictures_urls && r.pictures_urls.length ? 100 : 0) +
              (htmlToText(r.body_html).length > 40 ? 50 : 0) +
              Math.min(r.thumb_up || 0, 20)
            );
          };
          var diff = score(b) - score(a);
          return diff !== 0 ? diff : new Date(b.created_at) - new Date(a.created_at);
        });
    }

    return sorted;
  }

  /* ==================================================================
     通用图片灯箱 window.AmadaLightbox（2026-09-14 从 ReviewsBlock 抽出）
     ==================================================================
     为什么抽出来：Size Guide 抽屉的多图态也要「点一下放大」（运营 #5），
     而它跟评论区不在同一个组件里。灯箱本身是**一个页面只该有一份**的全局设施
     （一层遮罩、一份 ESC/方向键监听），再复制一份只会两份互相盖。

     ▍行为与抽出前逐条一致（回归口径 npm run qa:lightbox）
       · 打开：body 滚动锁、focus 落到关闭按钮
       · 渐进加载：先秒显缩略图，后台预载大图，onload 前比对 index 快照（铁律 33）
       · 多图才出现左右箭头与「n / N」计数
       · ESC / ← / → / 点遮罩空白 / 点叉 关闭或翻页；点大图本身不关
     ▍DOM 来源
       优先复用 snippets/amada-reviews-host.liquid 渲染的那一份（PDP / quick view
       都有评论区，实测两处 [data-reviews-lightbox] 都在）。找不到时按需**新建**一份
       同类名的 DOM 挂到 body —— 这样没有评论区的页面（例如只有抽屉的内容页）
       也能用，且样式直接吃 assets/amada-reviews.css 里现成的规则。
     ================================================================== */
  var AmadaLightbox = (function () {
    var el = null;                                   // { root, img, prev, next, count, close }
    var state = { items: [], index: 0, opener: null };
    var bound = false;

    /* 新建 DOM 时用的内联矢量：与 snippets/amada-reviews-icon.liquid 的
       close / chevron-left / chevron-right 三个分支逐字节相同（复制而不是近似，铁律 5）。 */
    var ICON_CLOSE =
      '<svg class="amada-reviews__icon amada-reviews__icon--close" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M5 5L19 19M19 5L5 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var CHEVRON_PATH =
      '<path d="M3.25 5L7.21875 8.96875C7.34375 9.09375 7.34375 9.28125 7.21875 9.40625C7.09375 9.53125 6.90625 9.53125 6.78125 9.40625L2.59375 5.21875C2.53125 5.15625 2.5 5.09375 2.5 5C2.5 4.90625 2.53125 4.84375 2.59375 4.78125L6.78125 0.59375C6.90625 0.46875 7.09375 0.46875 7.21875 0.59375C7.34375 0.71875 7.34375 0.90625 7.21875 1.03125L3.25 5Z" fill="currentColor"/>';
    var ICON_PREV =
      '<svg class="amada-reviews__icon amada-reviews__icon--chevron" viewBox="0 0 10 10" fill="none" aria-hidden="true" focusable="false">' +
      CHEVRON_PATH + '</svg>';
    /* 铁律 32：--flip 描述的是「这个图标朝哪边」（语义），不是某断点的布局差异，
       所以它在 amada-reviews.css 里是全局规则，这里直接复用不会踩到断点坑。 */
    var ICON_NEXT =
      '<svg class="amada-reviews__icon amada-reviews__icon--chevron amada-reviews__icon--flip" viewBox="0 0 10 10" fill="none" aria-hidden="true" focusable="false">' +
      CHEVRON_PATH + '</svg>';

    function build() {
      var box = document.createElement('div');
      box.className = 'amada-reviews__lightbox';
      box.setAttribute('data-reviews-lightbox', '');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Photo');
      box.hidden = true;
      box.innerHTML =
        '<button type="button" class="amada-reviews__lightbox-close" data-reviews-lightbox-close aria-label="Close">' + ICON_CLOSE + '</button>' +
        '<button type="button" class="amada-reviews__lightbox-nav amada-reviews__lightbox-nav--prev" data-reviews-lightbox-prev aria-label="Previous photo" hidden>' + ICON_PREV + '</button>' +
        '<figure class="amada-reviews__lightbox-figure"><img class="amada-reviews__lightbox-img" data-reviews-lightbox-img alt=""></figure>' +
        '<button type="button" class="amada-reviews__lightbox-nav amada-reviews__lightbox-nav--next" data-reviews-lightbox-next aria-label="Next photo" hidden>' + ICON_NEXT + '</button>' +
        '<span class="amada-reviews__lightbox-count" data-reviews-lightbox-count hidden></span>';
      document.body.appendChild(box);
      return box;
    }

    /** 只留 keep 这一份灯箱 DOM，其余（多为 quick view 重渲染留下的）就地删掉 */
    function dedupe(keep) {
      var all = document.querySelectorAll('[data-reviews-lightbox]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== keep && all[i].parentNode) all[i].parentNode.removeChild(all[i]);
      }
    }

    /**
     * 解析（必要时新建/搬家）灯箱 DOM。返回 null 表示这个环境用不了灯箱。
     *
     * 🚨 必须挂在 <body> 直下。灯箱是 position:fixed 全屏遮罩，而
     * assets/amada-drawer.css:89 给打开态的面板写的是 `transform: translateX(0)` ——
     * **translateX(0) 也是 transform**，它会给 fixed 后代造出新的包含块，
     * 于是「全屏」遮罩被压进 720 宽的抽屉里。
     * quick view 抽屉里的评论区自带一份 [data-reviews-lightbox]，正好踩这条。
     * 所以这里统一把它搬到 body，并清掉 quick view 反复 innerHTML 留下的重复节点
     * （重复节点会让 document.querySelector 抓到抽屉里那份废的，验收脚本也会跟着量错）。
     */
    function ensure() {
      if (el && document.contains(el.root)) { dedupe(el.root); return el; }
      var root = document.querySelector('[data-reviews-lightbox]') || build();
      if (root.parentElement !== document.body) document.body.appendChild(root);
      dedupe(root);
      el = {
        root: root,
        img: root.querySelector('[data-reviews-lightbox-img]'),
        prev: root.querySelector('[data-reviews-lightbox-prev]'),
        next: root.querySelector('[data-reviews-lightbox-next]'),
        count: root.querySelector('[data-reviews-lightbox-count]'),
        close: root.querySelector('[data-reviews-lightbox-close]'),
      };
      if (!el.img) { el = null; return null; }
      bind();
      return el;
    }

    /* 监听只绑一次（`bound` 守卫）。灯箱是全局单例，重复绑定会让
       「点一次下一张跳两张」，与 ReviewsBlock 里那次监听泄漏同源。 */
    function bind() {
      if (bound) return;
      bound = true;
      el.close.addEventListener('click', function () { close(); });
      /* 点遮罩空白关闭；点到图片/按钮本身不关（否则想看图反而被关掉） */
      el.root.addEventListener('click', function (e) { if (e.target === el.root) close(); });
      el.prev.addEventListener('click', function () { step(-1); });
      el.next.addEventListener('click', function () { step(1); });

      /* 🚨 必须挂在 **window 的捕获阶段**，不能是 document。
         assets/amada-modal.js:184 已经在 document 的捕获阶段吃 ESC，并且
         `stopImmediatePropagation()`（它要防止一次 ESC 连带关掉身后的抽屉）。
         事件流是 window(捕获) → document(捕获) → … ，所以只有挂到 window 才排得到它前面。
         实测：quick view 里从 size guide 弹窗打开灯箱后按 ESC，
         关掉的是**身后的弹窗**、灯箱还糊在屏幕上（PDP 上没这个问题，因为那条链路里
         只有 amada-drawer.js 的冒泡监听，不掐断）。
         灯箱是最顶层，处理完同样要掐断，否则一次 ESC 把弹窗/抽屉一起带走。 */
      window.addEventListener('keydown', function (e) {
        if (!el || el.root.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'ArrowRight') step(1);
        else return;
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.preventDefault();
      }, true);
    }

    /**
     * 打开灯箱。
     * @param {Array}   items  [{ thumb, full }]，thumb 用来秒显、full 是大图
     * @param {Number}  index  初始显示第几张
     * @param {Element} opener 触发元素，关闭后焦点还给它
     */
    function open(items, index, opener) {
      if (!ensure()) return false;
      if (!items || !items.length) return false;
      state.items = items;
      state.index = Math.max(0, Math.min(items.length - 1, index || 0));
      state.opener = opener || null;
      el.root.hidden = false;
      /* 锁滚动：不锁的话手机上背后的页面会跟着滑，看图时很容易滑丢位置 */
      document.body.style.overflow = 'hidden';
      sync();
      el.close.focus();
      return true;
    }

    function close() {
      if (!el) return;
      el.root.hidden = true;
      document.body.style.overflow = '';
      /* 焦点还给刚才点的那个元素，键盘用户不会被丢回页面顶部 */
      if (state.opener && typeof state.opener.focus === 'function') state.opener.focus();
      state.opener = null;
    }

    function step(delta) {
      var n = state.items.length;
      if (n < 2) return;
      state.index = (state.index + delta + n) % n; // 首尾循环
      sync();
    }

    function sync() {
      var n = state.items.length;
      var single = n < 2;
      var item = state.items[state.index] || { thumb: '', full: '' };
      var img = el.img;

      /* 第一步：立刻显示缩略图（浏览器缓存里已有，是瞬时的），
         并标记 is-loading 让 CSS 给一点「正在加载大图」的提示。 */
      img.src = item.thumb || item.full;
      img.classList.add('is-loading');

      /* 第二步：后台预载大图，到位后替换。
         用 index 快照防竞态：用户可能在大图回来之前就翻到下一张了，
         那时再替换会把「上一张的大图」盖到当前这张上（经典的图片错位 bug，铁律 33）。 */
      var wanted = state.index;
      if (item.full && item.full !== item.thumb) {
        var pre = new Image();
        pre.onload = function () {
          if (state.index !== wanted || el.root.hidden) return;
          img.src = item.full;
          img.classList.remove('is-loading');
        };
        pre.onerror = function () {
          /* 大图挂了就保留缩略图 —— 糊一点也好过空白 */
          if (state.index === wanted) img.classList.remove('is-loading');
        };
        pre.src = item.full;
      } else {
        img.classList.remove('is-loading');
      }

      el.prev.hidden = single;
      el.next.hidden = single;
      el.count.hidden = single;
      if (!single) el.count.textContent = state.index + 1 + ' / ' + n;
    }

    /** 把一组 <img> 直接转成灯箱条目（评论区与尺寸指南共用的取值口径） */
    function fromImages(imgs, opener) {
      return [].slice.call(imgs).map(function (n) {
        var holder = n.closest ? n.closest('[data-full-src]') : null;
        return {
          thumb: n.currentSrc || n.src,
          full: n.getAttribute('data-full') || (holder && holder.getAttribute('data-full-src')) || n.src,
        };
      });
    }

    return { open: open, close: close, step: step, fromImages: fromImages, ensure: ensure };
  })();

  window.AmadaLightbox = AmadaLightbox;

  /* ------------------------------------------------------------------
     组件
     ------------------------------------------------------------------ */

  function ReviewsBlock(root) {
    this.root = root;
    this.shopDomain = root.getAttribute('data-shop-domain');
    this.productId = root.getAttribute('data-product-id');
    this.productTitle = root.getAttribute('data-product-title') || '';
    this.perPage = parseInt(root.getAttribute('data-per-page'), 10) || 4;
    this.keywordCount = parseInt(root.getAttribute('data-keyword-count'), 10) || 6;
    this.curatedRaw = root.getAttribute('data-curated-keywords') || '';

    var extra = root.getAttribute('data-group-product-ids') || '';
    this.extraIds = extra
      .split(',')
      .map(function (v) {
        return v.trim();
      })
      .filter(Boolean);

    this.state = { sort: 'recommend', keyword: '', keywordTerms: [], country: '', page: 1 };
    this.data = null;
    this.filtered = [];

    this.el = {
      score: root.querySelector('[data-reviews-score]'),
      summaryStars: root.querySelector('[data-reviews-summary-stars]'),
      count: root.querySelector('[data-reviews-count]'),
      mentions: root.querySelector('[data-reviews-mentions]'),
      chips: root.querySelector('[data-reviews-chips]'),
      /* 分页/排序/筛选切换后回顶的兜底锚点：没有 TOP MENTIONS 时退到 SORT BY 行。
         见 amada-reviews-host.liquid 的 [data-reviews-top] 标记。 */
      topFallback: root.querySelector('[data-reviews-top]'),
      gallery: root.querySelector('[data-reviews-gallery]'),
      galleryTrack: root.querySelector('[data-reviews-gallery-track]'),
      list: root.querySelector('[data-reviews-list]'),
      empty: root.querySelector('[data-reviews-empty]'),
      pagination: root.querySelector('[data-reviews-pagination]'),
      cardTemplate: document.querySelector('[data-reviews-card-template]'),
    };

    /* 灯箱本体已抽成全局单例 window.AmadaLightbox（本文件上方），
       评论区只负责「哪些图算一组、点了哪一张」。 */

    /* 2026-09-02：quick view 抽屉里会**反复装卸**同一块评论区（换商品 / 关抽屉），
       所以挂在 document 上的监听必须可回收，否则每开一次抽屉多一份，
       表现是「点一次下拉关了 N 次」「ESC 一次触发多次」。root 上的监听随节点一起消失，不用记。 */
    this._docOff = [];

    this.init();
  }

  ReviewsBlock.prototype.init = function () {
    var self = this;

    this.buildSortPanel();
    this.bindEvents();

    fetchAll(this.shopDomain, this.productId, this.extraIds)
      .then(function (data) {
        /* 2026-09-02 第三轮：quick view 抽屉里换商品会 destroy 掉上一块，
           但它的 Judge.me 请求可能还在路上。晚到的响应必须**整个丢掉** ——
           否则它会继续 render 到已被 innerHTML 换掉的游离节点，
           更糟的是仍然广播 amada:reviews-loaded，把**上一个商品**的评分数
           盖到当前商品的评分行上（实测：0 评论商品的事件晚到，把 52 评论那件的行又藏了回去）。 */
        if (self.destroyed) return;
        self.data = data;
        self.keywords = resolveKeywords(data.reviews, self.curatedRaw, self.keywordCount, self.productTitle);
        self.countries = self.collectCountries(data.reviews);
        self.buildLocationPanel();
        self.renderSummary();
        self.renderGallery();
        self.renderChips();
        self.update();
        self.root.setAttribute('data-loaded', 'true');
        /* 2026-09-02：广播真实的均分/总数。
           quick view 标题下的评分行原本读 product.metafields.judgeme.rating —— 本店那个
           metafield 是空的（实测），所以那行永远不显示。改成「服务端从 judgeme.badge 取初值 +
           这里用评论模块拉到的真实数据回填」，两处同源，不会出现两个不一样的分数。 */
        document.dispatchEvent(new CustomEvent('amada:reviews-loaded', {
          detail: { root: self.root, average: data.average, total: data.total }
        }));
      })
      .catch(function (err) {
        /* 接口挂了就整块隐藏 —— 留一个空壳比不显示更糟（会在页面中间留白）。
           注意不能只 display:none 了事：apps section 的动画死锁坑说明
           「有占位没内容」是本站踩过的真实问题。 */
        self.root.setAttribute('data-failed', 'true');
        if (window.console) console.warn('[amada-reviews] 加载失败：', err.message);
      });
  };

  ReviewsBlock.prototype.collectCountries = function (reviews) {
    var seen = {};
    reviews.forEach(function (rev) {
      var code = (rev.location_country_code || '').toUpperCase();
      if (code) seen[code] = (seen[code] || 0) + 1;
    });
    return Object.keys(seen)
      .sort(function (a, b) {
        return seen[b] - seen[a];
      })
      .map(function (code) {
        return { code: code, label: COUNTRY_NAMES[code] || code };
      });
  };

  /* ---------- 下拉面板 ---------- */

  ReviewsBlock.prototype.buildSortPanel = function () {
    var dropdown = this.root.querySelector('[data-reviews-dropdown="sort"]');
    if (!dropdown) return;
    var panel = dropdown.querySelector('[data-reviews-dropdown-panel]');
    var html = SORT_OPTIONS.map(function (opt) {
      return '<button type="button" class="amada-reviews__dropdown-option" data-sort-key="' + opt.key + '">' + esc(opt.label) + '</button>';
    }).join('');
    panel.innerHTML = html;
    this.syncDropdownValue('sort');
  };

  ReviewsBlock.prototype.buildLocationPanel = function () {
    var dropdown = this.root.querySelector('[data-reviews-dropdown="location"]');
    if (!dropdown) return;

    // 只有一个国家（或没有国家数据）时整个筛选没有意义，直接隐藏
    if (this.countries.length < 2) {
      dropdown.hidden = true;
      return;
    }

    var panel = dropdown.querySelector('[data-reviews-dropdown-panel]');
    var options = [{ code: '', label: 'ALL REVIEWS' }].concat(this.countries);
    panel.innerHTML = options
      .map(function (opt) {
        return '<button type="button" class="amada-reviews__dropdown-option" data-country="' + esc(opt.code) + '">' + esc(opt.label) + '</button>';
      })
      .join('');
    this.syncDropdownValue('location');
  };

  ReviewsBlock.prototype.syncDropdownValue = function (type) {
    var dropdown = this.root.querySelector('[data-reviews-dropdown="' + type + '"]');
    if (!dropdown) return;
    var valueEl = dropdown.querySelector('[data-reviews-dropdown-value]');
    if (!valueEl) return;

    if (type === 'sort') {
      var current = SORT_OPTIONS.filter(
        function (o) {
          return o.key === this.state.sort;
        }.bind(this)
      )[0];
      valueEl.textContent = current ? current.activeLabel : '';
    } else {
      var country = this.state.country;
      var match = this.countries &&
        this.countries.filter(function (c) {
          return c.code === country;
        })[0];
      valueEl.textContent = match ? match.label : 'ALL REVIEWS';
    }
  };

  ReviewsBlock.prototype.closeDropdowns = function (except) {
    var list = this.root.querySelectorAll('[data-reviews-dropdown]');
    for (var i = 0; i < list.length; i++) {
      if (list[i] === except) continue;
      list[i].querySelector('[data-reviews-dropdown-panel]').hidden = true;
      list[i].querySelector('[data-reviews-dropdown-trigger]').setAttribute('aria-expanded', 'false');
    }
  };

  /* ---------- 事件 ---------- */

  /** document 级监听的可回收包装（见构造器里 _docOff 的说明） */
  ReviewsBlock.prototype._onDoc = function (type, fn, capture) {
    document.addEventListener(type, fn, capture);
    this._docOff.push([type, fn, capture]);
  };

  ReviewsBlock.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-reviews-dropdown-trigger]');
      if (trigger) {
        var dropdown = trigger.closest('[data-reviews-dropdown]');
        var panel = dropdown.querySelector('[data-reviews-dropdown-panel]');
        var willOpen = panel.hidden;
        self.closeDropdowns(dropdown);
        panel.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', String(willOpen));
        return;
      }

      var sortOption = e.target.closest('[data-sort-key]');
      if (sortOption) {
        self.state.sort = sortOption.getAttribute('data-sort-key');
        self.state.page = 1;
        self.syncDropdownValue('sort');
        self.closeDropdowns();
        self.update();
        // 排序换的是整页内容，和分页同规则回到评论区起始锚点
        self.scrollToTop();
        return;
      }

      var countryOption = e.target.closest('[data-country]');
      if (countryOption) {
        self.state.country = countryOption.getAttribute('data-country');
        self.state.page = 1;
        self.syncDropdownValue('location');
        self.closeDropdowns();
        self.update();
        // LOCATION 筛选同样会换整页内容
        self.scrollToTop();
        return;
      }

      var chip = e.target.closest('[data-keyword]');
      if (chip) {
        var word = chip.getAttribute('data-keyword');
        // 再点一次已选中的 chip = 取消筛选（稿没画取消态，但不给退路是死路）
        var isOff = self.state.keyword === word;
        self.state.keyword = isOff ? '' : word;
        self.state.keywordTerms = isOff ? [] : self.termsOf(word);
        self.state.page = 1;
        self.renderChips();
        self.update();
        // TOP MENTIONS 筛选同样会换整页内容
        self.scrollToTop();
        return;
      }

      var pageBtn = e.target.closest('[data-page]');
      if (pageBtn) {
        var target = pageBtn.getAttribute('data-page');
        var totalPages = Math.max(1, Math.ceil(self.filtered.length / self.perPage));
        if (target === 'prev') self.state.page = Math.max(1, self.state.page - 1);
        else if (target === 'next') self.state.page = Math.min(totalPages, self.state.page + 1);
        else self.state.page = parseInt(target, 10) || 1;
        self.update();
        // 翻页后回到评论区起始锚点（TOP MENTIONS 标题 / 无则 SORT BY 行），
        // 而不是停在页脚 —— 否则用户看不到新一页的开头
        self.scrollToTop();
        return;
      }

      var prevArrow = e.target.closest('[data-reviews-gallery-prev]');
      var nextArrow = e.target.closest('[data-reviews-gallery-next]');
      if (prevArrow || nextArrow) {
        var track = self.el.galleryTrack;
        if (!track) return;
        var step = track.clientWidth * 0.8;
        track.scrollBy({ left: prevArrow ? -step : step, behavior: 'smooth' });
      }
    });

    /* 点下拉之外的任何地方都关闭 —— 判定基准是「有没有落在某个 dropdown 里」，
       不是「有没有落在评论区里」。用后者的话，点评论区标题/卡片时面板会赖着不走。 */
    self._onDoc('click', function (e) {
      if (!e.target.closest('[data-reviews-dropdown]')) self.closeDropdowns();
    });

    /* 图片加载失败兜底：买家上传的图存在 Judge.me 侧，链接可能失效。
       img 的 error 事件不冒泡，必须用捕获阶段监听。
       图库里失败就整格移除；评论卡里失败就移除那一张，都空了再收起整块。 */
    this.root.addEventListener(
      'error',
      function (e) {
        var img = e.target;
        if (!img || img.tagName !== 'IMG') return;

        var galleryItem = img.closest('.amada-reviews__gallery-item');
        if (galleryItem) {
          var track = galleryItem.parentNode;
          galleryItem.remove();
          if (track && !track.children.length && self.el.gallery) self.el.gallery.hidden = true;
          return;
        }

        var media = img.closest('.amada-review-card__media');
        if (media) {
          img.remove();
          if (!media.children.length) media.hidden = true;
        }
      },
      true
    );

    this.bindLightbox();

    self._onDoc('keydown', function (e) {
      if (e.key === 'Escape') self.closeDropdowns();
    });
  };

  /* ---------- 图片灯箱 ----------
     运营 2026-08-05：图片墙和评论卡里的图都要能点开放大、再叉掉。
     稿里没画（移动稿把「点击是否开灯箱」列为待确认项），交互规则见 section 里的注释。 */

  ReviewsBlock.prototype.bindLightbox = function () {
    var self = this;

    /* 点图片开灯箱。用委托挂在 root 上：图片是异步渲染 + 翻页重建的，
       逐个绑定会在下一次 render 后全部失效。 */
    this.root.addEventListener('click', function (e) {
      var img = e.target.closest('.amada-reviews__gallery-item img, .amada-review-card__media img');
      if (!img) return;
      e.preventDefault();
      self.openLightbox(img);
    });
  };

  ReviewsBlock.prototype.openLightbox = function (img) {
    /* 同一组内的所有图一起进灯箱，这样点开后能左右翻 —— 图片墙是整条轨道，
       评论卡是那张卡自己的图，两者不混。 */
    var group = img.closest('.amada-reviews__gallery-track, .amada-review-card__media');
    var imgs = group ? [].slice.call(group.querySelectorAll('img')) : [img];

    /* thumb + full 两份的取值口径见 AmadaLightbox.fromImages：
       Judge.me 的 original 是 1024px 大图，移动端实测要 10 秒以上才加载完，
       只给 full 的话用户点开后对着黑屏干等（第一版就是这样，截图才发现）。 */
    window.AmadaLightbox.open(
      window.AmadaLightbox.fromImages(imgs),
      Math.max(0, imgs.indexOf(img)),
      img
    );
  };

  ReviewsBlock.prototype.closeLightbox = function () {
    window.AmadaLightbox.close();
  };

  ReviewsBlock.prototype.stepLightbox = function (delta) {
    window.AmadaLightbox.step(delta);
  };

  /* ---------- 渲染 ---------- */

  ReviewsBlock.prototype.starsHtml = function (rating, size) {
    // 稿只画了满星，没有半星/空星样式（PC 规格 A2）。
    // 这里用「满星 + 半星裁切 + 空星降透明」实现，形状始终是稿的圆角星。
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var state = rating >= i ? 'full' : rating >= i - 0.5 ? 'half' : 'empty';
      html += '<span class="amada-reviews__star amada-reviews__star--' + state + '"></span>';
    }
    return html;
  };

  ReviewsBlock.prototype.renderSummary = function () {
    var avg = this.data.average;
    // 稿写「4.6/5」：一位小数
    if (this.el.score) this.el.score.textContent = (Math.round(avg * 10) / 10).toFixed(1) + '/5';
    if (this.el.summaryStars) this.el.summaryStars.innerHTML = this.starsHtml(avg);
    if (this.el.count) {
      // 稿文案「Based on 38 reviews globally」——「globally」只在做了跨商品聚合时才成立，
      // 没配聚合商品就不写，避免自我夸大。
      var suffix = this.extraIds.length ? ' globally' : '';
      this.el.count.textContent = 'Based on ' + this.data.total + ' review' + (this.data.total === 1 ? '' : 's') + suffix;
    }
  };

  ReviewsBlock.prototype.renderGallery = function () {
    var photos = [];
    this.data.photoGallery.forEach(function (item) {
      (item.pictures_urls || []).forEach(function (pic) {
        photos.push({ url: pic.compact || pic.huge || pic.original, full: pic.original || pic.huge });
      });
    });

    // 图库为空就整块隐藏（脏数据场景：没有买家秀的新品）
    if (!photos.length) {
      if (this.el.gallery) this.el.gallery.hidden = true;
      return;
    }

    this.el.gallery.hidden = false;
    /* data-full 存大图地址供灯箱用：列表里放的是 compact 缩略图，
       直接把它放大会糊 —— 必须换成 original/huge 再显示。 */
    this.el.galleryTrack.innerHTML = photos
      .map(function (p) {
        return (
          '<div class="amada-reviews__gallery-item">' +
          '<img src="' + esc(p.url) + '" data-full="' + esc(p.full || p.url) + '"' +
          ' alt="" loading="lazy" width="180" height="180" tabindex="0" role="button">' +
          '</div>'
        );
      })
      .join('');
  };

  /* chip 上显示的是 label，筛选要用的是它背后的 terms —— 用 label 反查 */
  ReviewsBlock.prototype.termsOf = function (label) {
    var hit = (this.keywords || []).filter(function (k) {
      return k.label === label;
    })[0];
    return hit ? hit.terms : [label.toLowerCase()];
  };

  ReviewsBlock.prototype.renderChips = function () {
    if (!this.el.chips) return;

    if (!this.keywords || !this.keywords.length) {
      this.el.mentions.hidden = true;
      return;
    }

    this.el.mentions.hidden = false;
    var current = this.state.keyword;
    this.el.chips.innerHTML = this.keywords
      .map(function (kw) {
        var active = kw.label === current;
        return (
          '<button type="button" class="amada-reviews__chip' + (active ? ' is-active' : '') + '"' +
          ' data-keyword="' + esc(kw.label) + '" aria-pressed="' + active + '">' +
          esc(kw.label) +
          '</button>'
        );
      })
      .join('');
  };

  ReviewsBlock.prototype.renderList = function () {
    var start = (this.state.page - 1) * this.perPage;
    var pageItems = this.filtered.slice(start, start + this.perPage);
    var template = this.el.cardTemplate;
    var list = this.el.list;

    list.innerHTML = '';

    if (!pageItems.length) {
      this.el.empty.hidden = false;
      return;
    }
    this.el.empty.hidden = true;

    var self = this;
    pageItems.forEach(function (rev) {
      var node = template.content.firstElementChild.cloneNode(true);

      node.querySelector('.amada-review-card__name').textContent = rev.reviewer_name || 'Anonymous';
      node.querySelector('.amada-review-card__stars').innerHTML = self.starsHtml(rev.rating);

      var dateEl = node.querySelector('.amada-review-card__date');
      dateEl.textContent = formatDate(rev.created_at);
      dateEl.setAttribute('datetime', rev.created_at || '');

      var code = (rev.location_country_code || '').toUpperCase();
      if (code) {
        var locEl = node.querySelector('.amada-review-card__location');
        locEl.hidden = false;
        locEl.querySelector('.amada-review-card__country').textContent = COUNTRY_NAMES[code]
          ? COUNTRY_NAMES[code].replace(/\b\w+/g, function (w) {
              return w.charAt(0) + w.slice(1).toLowerCase();
            })
          : code;
      }

      if (rev.title) {
        var titleEl = node.querySelector('.amada-review-card__title');
        titleEl.hidden = false;
        /* 2026-10-06：评论接口返回的标题本身已是 HTML 转义（wasn&#39;t），直接塞 textContent
           会把实体原样显示出来。用 DOMParser（惰性文档，不加载图片、不执行脚本）解码一次再写。 */
        titleEl.textContent = fixMojibake(decodeEntities(rev.title));
      }

      /* 「只打星没写字」的评论，Judge.me 会填 `Verified purchase. Rated 5 stars.`。
         照原样显示等于让假文案冒充买家评价 —— 这类卡片只留姓名/星/日期。 */
      var bodyText = htmlToText(rev.body_html);
      var bodyEl = node.querySelector('.amada-review-card__body');
      if (isPlaceholder(bodyText)) {
        bodyEl.hidden = true;
      } else {
        bodyEl.textContent = bodyText;
      }

      var pics = rev.pictures_urls || [];
      if (pics.length) {
        var mediaEl = node.querySelector('.amada-review-card__media');
        mediaEl.hidden = false;
        mediaEl.innerHTML = pics
          .slice(0, 4)
          .map(function (pic) {
            var src = pic.compact || pic.original || pic.huge;
            var full = pic.original || pic.huge || src; /* 灯箱要大图，缩略图放大会糊 */
            return '<img src="' + esc(src) + '" data-full="' + esc(full) + '"' +
              ' alt="" loading="lazy" width="80" height="80" tabindex="0" role="button">';
          })
          .join('');
      }

      // 「Review on similar product」：只在这条评论来自别的商品时才出现
      if (!rev.__ownProduct && rev.product_title) {
        var similar = node.querySelector('.amada-review-card__similar');
        similar.hidden = false;
        similar.querySelector('.amada-review-card__similar-label').textContent = 'Review on similar product ';
        var link = similar.querySelector('.amada-review-card__similar-link');
        link.textContent = rev.product_title;
        link.href = rev.product_url || '#';
      }

      list.appendChild(node);
    });
  };

  ReviewsBlock.prototype.renderPagination = function () {
    var totalPages = Math.ceil(this.filtered.length / this.perPage);
    var nav = this.el.pagination;

    if (totalPages <= 1) {
      nav.hidden = true;
      return;
    }
    nav.hidden = false;

    var current = this.state.page;
    // 稿画的是 1·2·3·4·5·…·79 —— 首 5 页 + 省略号 + 末页。
    // 当前页翻到后面时窗口跟着走，否则点不到中间页。
    var pages = [];
    if (totalPages <= 7) {
      for (var i = 1; i <= totalPages; i++) pages.push(i);
    } else if (current <= 4) {
      pages = [1, 2, 3, 4, 5, '...', totalPages];
    } else if (current >= totalPages - 3) {
      pages = [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      pages = [1, '...', current - 1, current, current + 1, '...', totalPages];
    }

    var html = '<button type="button" class="amada-reviews__page-arrow" data-page="prev"' + (current === 1 ? ' disabled' : '') + ' aria-label="Previous page"></button>';
    html += '<span class="amada-reviews__page-numbers">';
    pages.forEach(function (p) {
      if (p === '...') {
        html += '<span class="amada-reviews__page amada-reviews__page--gap">...</span>';
      } else {
        html +=
          '<button type="button" class="amada-reviews__page' + (p === current ? ' is-current' : '') + '"' +
          ' data-page="' + p + '"' + (p === current ? ' aria-current="page"' : '') + '>' + p + '</button>';
      }
    });
    html += '</span>';
    html += '<button type="button" class="amada-reviews__page-arrow amada-reviews__page-arrow--next" data-page="next"' + (current === totalPages ? ' disabled' : '') + ' aria-label="Next page"></button>';

    nav.innerHTML = html;
  };

  ReviewsBlock.prototype.update = function () {
    this.filtered = applyFilters(this.data.reviews, this.state);
    var totalPages = Math.max(1, Math.ceil(this.filtered.length / this.perPage));
    if (this.state.page > totalPages) this.state.page = totalPages;
    this.renderList();
    this.renderPagination();
  };

  /* ---------- 分页/排序/筛选切换后回到评论区起始锚点 ----------
     锚点：TOP MENTIONS 标题顶部；该商品没有 TOP MENTIONS（chips 为空、
     [data-reviews-mentions] 仍是 hidden）时退到 SORT BY 行（工具条）顶部。
     只有用户主动切换分页/排序/筛选时才调用本方法 —— 首次加载（init 里的
     第一次 update）不会走到这里，因为那次调用没有跟在这个方法后面。 */
  ReviewsBlock.prototype.getTopAnchor = function () {
    if (this.el.mentions && !this.el.mentions.hidden) return this.el.mentions;
    return this.el.topFallback || this.root.querySelector('.amada-reviews__toolbar');
  };

  ReviewsBlock.prototype.scrollToTop = function () {
    var anchor = this.getTopAnchor();
    if (!anchor) return;

    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    var MARGIN = 24; // 稿间距余量

    /* quick view 抽屉里真正滚动的是 .amada-drawer__body（唯一可滚动区，
       见 amada-drawer.css 里的注释），不是 window —— 抽屉头部本身就在
       该容器之外，不占用它的滚动空间，所以这里不用再扣一次 header 高度。
       PDP 上 root 不在任何抽屉里，closest 返回 null，走 window 分支。 */
    var drawerBody = this.root.closest('.amada-drawer__body');
    if (drawerBody) {
      var delta = anchor.getBoundingClientRect().top - drawerBody.getBoundingClientRect().top;
      var target = Math.max(0, drawerBody.scrollTop + delta - MARGIN);
      if (drawerBody.scrollTo) drawerBody.scrollTo({ top: target, behavior: behavior });
      else drawerBody.scrollTop = target;
      return;
    }

    var y = window.scrollY + anchor.getBoundingClientRect().top - getStickyHeaderHeight() - MARGIN;
    window.scrollTo({ top: Math.max(0, y), behavior: behavior });
  };

  /* ------------------------------------------------------------------
     启动
     ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     顶部星评「N reviews」→ 滚到评论区
     --------------------------------------------------------------------
     Judge.me 的 preview badge 自带点击行为：滚到**它自己的** review widget
     （`.jdgm-rev-widg`）。我们把官方 widget 停用、换成了自建区块，
     它的目标就不存在了 → 点了毫无反应（运营实测反馈）。这里接管。

     用捕获阶段监听：要抢在 Judge.me 自己的 handler 之前拦下，
     否则它会先把页面滚到一个不存在的位置。
     ------------------------------------------------------------------ */
  var JUMP_TRIGGERS = [
    '.jdgm-prev-badge', // Judge.me preview badge（当前 PDP 顶部用的就是它）
    '.jdgm-preview-badge',
    '.jdgm-widget.jdgm-preview-badge',
    '.dd-review', // dadao 历史遗留，若页面上还有
    '[data-amada-reviews-jump]', // 想手动挂入口时用
  ].join(',');

  function scrollToReviews(block) {
    /* 头部若脱离文档流（fixed/sticky），要减掉它的高度，否则标题会被压在头部底下。
       本主题实测 `.header` 是 static（视觉固定由别的方式实现），算出来是 0，
       此时评论区标题落在 106px 而头部只占 0–70，正好不重叠。 */
    var headerH = getStickyHeaderHeight();

    var go = function () {
      var y = window.scrollY + block.getBoundingClientRect().top - headerH - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    };
    go();

    /* 评论数据是异步拉的，区块高度会在加载完后变化 —— 只滚一次会停在错位置。
       未加载完时等 data-loaded 再校正一遍。 */
    if (!block.getAttribute('data-loaded')) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (block.getAttribute('data-loaded') || tries > 20) {
          clearInterval(timer);
          setTimeout(go, 120);
        }
      }, 250);
    }
  }

  function initRatingJump() {
    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest && e.target.closest(JUMP_TRIGGERS);
        if (!trigger) return;
        var block = document.querySelector('[data-amada-reviews]');
        if (!block) return; // 页面上没有自建评论区就别拦，交回原生行为
        /* 2026-09-02：分类页现在也会加载本文件（quick view 抽屉里有评论区）。
           商品卡上的 Judge.me 徽标与抽屉里的评论区**不在同一个容器**，
           这时拦下来会把用户莫名其妙滚进抽屉。只有触发器和评论区同属一个抽屉时才接管。
           PDP 上评论区不在抽屉里，drawer 为 null，行为与之前完全一致。 */
        var drawer = block.closest('[data-amada-drawer]');
        if (drawer && !drawer.contains(trigger)) return;
        e.preventDefault();
        e.stopPropagation();
        scrollToReviews(block);
      },
      true
    );

    // 支持带锚点进来（Judge.me 官方链接惯用 #judgeme_product_reviews）
    if (/#(judgeme_product_reviews|reviews|amada-reviews)/.test(location.hash)) {
      var block = document.querySelector('[data-amada-reviews]');
      if (block) setTimeout(function () { scrollToReviews(block); }, 300);
    }
  }

  /**
   * scope 省略时扫全页（原行为）；传节点时只扫该节点内部（含节点自身）。
   * quick view 的评论区是 AJAX innerHTML 进来的，DOMContentLoaded / shopify:section:load
   * 都早就过去了，必须由 quick view 填完 payload 后主动 boot(抽屉)。
   */
  function boot(scope) {
    var host = scope || document;
    var blocks = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-amada-reviews]')) blocks.push(scope);
    var found = host.querySelectorAll('[data-amada-reviews]');
    for (var k = 0; k < found.length; k++) blocks.push(found[k]);
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].__amadaReviews) continue;
      blocks[i].__amadaReviews = new ReviewsBlock(blocks[i]);
    }
    return blocks.length;
  }

  /**
   * 拆掉一块评论区：回收 document 级监听 + 清实例标记。
   * 不回收的话，quick view 每换一次商品就多一份下拉/ESC 监听（监听泄漏）。
   * 在途请求不取消 —— 它写的是已经被 innerHTML 换掉的游离节点，写不到页面上。
   */
  function destroy(scope) {
    var host = scope || document;
    var blocks = [];
    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('[data-amada-reviews]')) blocks.push(scope);
    var found = host.querySelectorAll('[data-amada-reviews]');
    for (var k = 0; k < found.length; k++) blocks.push(found[k]);
    for (var i = 0; i < blocks.length; i++) {
      var inst = blocks[i].__amadaReviews;
      if (!inst) continue;
      var off = inst._docOff || [];
      for (var j = 0; j < off.length; j++) document.removeEventListener(off[j][0], off[j][1], off[j][2]);
      inst._docOff = [];
      inst.destroyed = true;
      blocks[i].__amadaReviews = null;
    }
    return blocks.length;
  }

  window.AmadaReviews = { boot: boot, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      initRatingJump();
    });
  } else {
    boot();
    initRatingJump();
  }

  // 主题编辑器里增删 section 后重新挂载（跳转是全局委托，不用重挂）
  document.addEventListener('shopify:section:load', boot);
})();
